'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = exports.styleSheet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _PropTypes = require('../utils/PropTypes');

var _PropTypes2 = _interopRequireDefault(_PropTypes);

var _jssThemeReactor = require('jss-theme-reactor');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var styleSheet = exports.styleSheet = (0, _jssThemeReactor.createStyleSheet)('SegmentedProgress', function (theme) {
  return {
    root: {
      display: 'flex',
      alignItems: 'center',
      height: theme.typography.verticalScaledRhythmByPixel(13).lineHeight,
      color: theme.palette.text.highlight
    },
    error: {
      color: theme.palette.text.error
    },
    segment: {
      marginRight: 1,
      width: '1em',
      height: '1em',
      borderRadius: theme.variables.borderRadius,
      backgroundColor: theme.palette.background['default']
    },
    shaded: {
      backgroundColor: 'currentColor'
    }
  };
});

var SegmentedProgress = (_temp2 = _class = function (_Component) {
  _inherits(SegmentedProgress, _Component);

  function SegmentedProgress() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SegmentedProgress);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SegmentedProgress.__proto__ || Object.getPrototypeOf(SegmentedProgress)).call.apply(_ref, [this].concat(args))), _this), _this.getSegments = function (_ref2) {
      var segmentSize = _ref2.segmentSize,
          valuemax = _ref2.valuemax;
      return ' '.repeat(segmentSize).split('').map(function (v, i) {
        return Math.ceil(i === 0 ? i : i * (valuemax / (segmentSize - 1)) - 1);
      });
    }, _this.getTitle = function (_ref3) {
      var value = _ref3.value,
          valuemax = _ref3.valuemax;
      return Math.round(value / valuemax * 100) + '%';
    }, _this.state = {
      segmentSize: _this.getSegments(_this.props),
      title: _this.getTitle(_this.props)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SegmentedProgress, [{
    key: 'componentWillReceiveProps',
    value: function () {
      function componentWillReceiveProps(props) {
        if (props.segmentSize === this.props.segmentSize && props.value === this.props.value && props.valuemax === this.props.valuemax) {
          return;
        }

        this.setState({
          segmentSize: this.getSegments(props),
          title: this.getTitle(props)
        });
      }

      return componentWillReceiveProps;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        var _props = this.props,
            classNameProp = _props.className,
            error = _props.error,
            segmentSizeProp = _props.segmentSize,
            value = _props.value,
            valuemax = _props.valuemax,
            other = _objectWithoutProperties(_props, ['className', 'error', 'segmentSize', 'value', 'valuemax']);

        var _state = this.state,
            segmentSize = _state.segmentSize,
            title = _state.title;

        var classes = this.context.styleManager.render(styleSheet);
        var rootClassName = (0, _classnames2['default'])(classes.root, _defineProperty({}, classes.error, error), classNameProp);
        var segmentClassName = function () {
          function segmentClassName(percent) {
            return (0, _classnames2['default'])(classes.segment, _defineProperty({}, classes.shaded, value > percent));
          }

          return segmentClassName;
        }();

        return _react2['default'].createElement(
          'div',
          _extends({
            'aria-valuemax': '' + valuemax // eslint-disable-line jsx-a11y/aria-proptypes
            , 'aria-valuemin': '0',
            'aria-valuenow': '' + value // eslint-disable-line jsx-a11y/aria-proptypes
            , className: rootClassName,
            role: 'progressbar'
          }, Object.assign({ title: title }, other)),
          segmentSize.map(function (percent, i) {
            return _react2['default'].createElement('div', { className: segmentClassName(percent), key: i });
          })
        );
      }

      return render;
    }()
  }]);

  return SegmentedProgress;
}(_react.Component), _class.propTypes = {
  /**
   * The CSS class name of the root element.
   */
  className: _PropTypes2['default'].string,
  /**
   * If true, segment elements have 'error' color.
   */
  error: _PropTypes2['default'].bool,
  /**
   * The number of segments.
   */
  segmentSize: _PropTypes2['default'].number,
  /**
   * The value of progress.
   */
  value: _PropTypes2['default'].number,
  /**
   * The max value of progress.
   */
  valuemax: _PropTypes2['default'].number
}, _class.defaultProps = {
  error: false,
  segmentSize: 6,
  value: 0,
  valuemax: 100
}, _class.contextTypes = {
  styleManager: _PropTypes2['default'].styleManager.isRequired
}, _temp2);
exports['default'] = SegmentedProgress;


SegmentedProgress.displayName = 'SegmentedProgress';


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/Progress/SegmentedProgress.js
// module id = 736
// module chunks = 32